// extracted by mini-css-extract-plugin
export var label = "_be-1";
export var reminder = "_be-0";